import { useContext, useEffect, useState } from "react";
import { EnvironmentContext, environments } from "../../../config/EnvironmentContext";
import { useToken } from "./token";
const defaultOpts = {};

export const useFetch = (input, opts = defaultOpts, refreshFlag = true, location = "location") => {
  const { token } = useToken();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const { readBody = (body) => body.json() } = opts;
  const env = useContext(EnvironmentContext);
  const abortController = new AbortController();
  const signal = abortController.signal;

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
  useEffect(() => {
    (async () => {
      if (input && refreshFlag && token) {
        let url = environments[location][env] + input;
        setLoading(true);
        let tokenType = token.tokenType.charAt(0).toUpperCase() + token.tokenType.substr(1).toLowerCase();
        try {
          const response = await fetch(url, {
            headers: {
              Authorization: tokenType + " " + token.token,
            },
            signal: signal,
          });
          if (response.ok) {
            const body = await readBody(response);
            setData(body);
          } else {
            const body = await readBody(response);
            console.error("error", body);
            setError(body.message);
          }
        } catch (e) {
          console.error("Request error", e.message);
          setError(e.message);
        } finally {
          setLoading(false);
        }
      }
    })();
  }, [input, opts, refreshFlag, token]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
  useEffect(() => {
    return () => {
      abortController.abort();
    };
  }, []);

  return { error, loading, data };
};
